import React, { useEffect, useState } from 'react'
import { makeStyles } from '@mui/styles'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import { Title } from '@/modules/base/components/texts'
import { ButtonIconSquare, CancelButton } from '@/modules/base/components/buttons'
import lang from '@/lang'
import IconCheck from 'assets/images/icons/check.svg'

const initialState = {
  doDisplayWait: false,
}

export const RedirectModal = (props) => {
  const { transaction, onSuccess, onAbort, onError, ...otherProps } = props
  const classes = useStyles(props)
  const [state, setState] = useState(initialState)
  const { doDisplayWait } = state

  useEffect(() => {
    setState({ ...initialState })
  }, [])

  const handleRedirect = ({ state, setState, transaction }) => {
    return () => {
      const { provideRedirectRequest: { redirectUri } } = transaction
      setState({ ...state, doDisplayWait: true })
      window.open(redirectUri, '_blank ')
    }
  }
  const handleContinueTransaction = ({ transaction }) => {
    return () => onSuccess(transaction)
  }

  let onNext = handleRedirect

  const title = lang.bankAccountSetupRedirectInitTitle
  let submitButtonLabel = lang.continueButtonLabel
  let description = (
    <p className={classes.description}>{lang.bankAccountSetupRedirectInitDescription}</p>)

  if (doDisplayWait) {
    description = (
      <p className={classes.description}>{lang.bankAccountSetupRedirectPendingDescription}</p>)
    onNext = handleContinueTransaction
    submitButtonLabel = lang.closeButtonLabel

  }

  return (
    <Dialog {...otherProps}>
      <div className={classes.root}>
        <div className={classes.contentContainer}>
          <DialogContent classes={{ root: classes.dialogContainer }}>
            <Title position="center">{title}</Title>
            {description}
          </DialogContent>
          <DialogActions classes={{ root: classes.actions }}>
            <CancelButton
              key='cancel'
              type='cancel'
              label={lang.cancelButtonLabel}
              onClick={() => onAbort(transaction)} />
            <ButtonIconSquare
              key='confirm'
              customClass={classes.actionButton}
              type='submit'
              icon={IconCheck}
              label={submitButtonLabel}
              onClick={onNext({ state, setState, transaction })} />
          </DialogActions>
        </div>
      </div>
    </Dialog>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    minHeight: 400,
  },
  dialogContainer: {
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    justifyContent: 'center',
  },
  teaser: {
    width: 300,
    backgroundColor: theme.primaryColors.custom1,
  },
  actions: {
    padding: '0 30px 30px',
  },
}))

export default RedirectModal
